import axios from "axios";
import { baseUrl } from "./axiosClient";

const getAdminToken = () => localStorage.getItem("adminToken");

const adminClient = axios.create({
  baseURL: `${baseUrl}admin/`,
});

adminClient.interceptors.request.use((config) => ({
  ...config,
  headers: {
    ...(config.headers || {}),
    "Content-Type": "application/json",
    authorization: `Bearer ${getAdminToken()}`,
  },
}));

adminClient.interceptors.response.use(
  (response) => response.data,
  (err) => {
    throw err.response || err;
  }
);

const adminApi = {
  login: (params) => adminClient.post("login", params),
  getStats: (params) => adminClient.get("stats", { params }),
  resetUserAiQuota: (userId) =>
    adminClient.post(`users/${userId}/ai-quota/reset`),
  resetUserPassword: (userId, params) =>
    adminClient.post(`users/${userId}/reset-password`, params),
};

export default adminApi;
